<template>
    <div id="app">
        <v-app id="inspire">
            <v-layout row wrap>
                <v-flex sx12>
                    <div class="text-xs-center">
                        <v-card-title class="headline font-weight-regular justify-center">
                        </v-card-title>
                    </div>
                </v-flex>
            </v-layout>
            <br>

            <v-container grid-list-md>
                <v-expansion-panel v-model="panel" expand popout>
                    <v-expansion-panel-content class="blue-grey darken-3">
                        <template v-slot:actions>
                            <v-icon color="green lighten-1">$vuetify.icons.expand</v-icon>
                        </template>
                        <template v-slot:header>
                            <div>
                                <v-card-title class="title font-weight-medium white--text">FOR APPROVAL APPOINTMENTS</v-card-title>
                            </div>
                        </template>

                        <v-card class="mx-auto scrollCard grey lighten-5" max-width="100%" v-if="forApproval.length > 0">
                            <v-card-text class="py-0">
                                <v-timeline align-top dense>
                                    <v-slide-x-reverse-transition group>
                                        <v-timeline-item v-for="(list, index) in forApproval" :key="index" color="amber darken-4" small>
                                            <v-layout row wrap> 
                                                <v-flex lg6 xs12>
                                                    <v-card-title class="subheading font-weight-black pb-0">
                                                       Control Number: {{list.transactionId}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black pt-0 pb-0">
                                                        {{list.branch}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.formatedDate }}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.appointmentTime }}
                                                    </v-card-title>
                                                </v-flex>
                                                    
                                                <v-flex lg6 xs12> 
                                                    <v-card-title class="subheading font-weight-black pb-0">Work Requested : 
                                                        <v-flex xs12 v-for="(service,index) in list.initialService" :key="index">
                                                            <li class="subheading font-weight-bold left">{{service.displayName}}</li> 
                                                        </v-flex> 
                                                    </v-card-title> 

                                                    <v-card-title class="subheading font-weight-black pt-0" v-if="list.otherService.length > 0">Others : 
                                                        <v-flex xs12 v-for="(service,index) in list.otherService" :key="index">
                                                            <li class="subheading font-weight-bold left">{{service.service}}</li> 
                                                        </v-flex> 
                                                    </v-card-title>
                                                </v-flex> 
                                            </v-layout>
                                        </v-timeline-item>
                                    </v-slide-x-reverse-transition>
                                </v-timeline>
                            </v-card-text>
                        </v-card>

                        <v-layout v-if="forApproval.length === 0" row wrap  class="mx-auto scrollCard grey lighten-5">
                            <v-flex xs12 sm12 md12 lg12>
                                <div class="text-xs-center">
                                    <br><br>
                                    <v-icon size="80">event_busy</v-icon>
                                    <v-card-title class="headline font-weight-regular justify-center">EMPTY APPROVAL TRANSACTIONS
                                    </v-card-title>
                                    <br><br>
                                </div>
                            </v-flex>
                        </v-layout> 
                    </v-expansion-panel-content>

                    <v-expansion-panel-content class="blue-grey darken-3">
                        <template v-slot:actions>
                            <v-icon color="green lighten-1">$vuetify.icons.expand</v-icon>
                        </template>
                        <template v-slot:header>
                            <div>
                                <v-card-title class="title font-weight-medium white--text">MY PENDING APPOINTMENTS</v-card-title>
                            </div>
                        </template>

                        <v-card class="mx-auto scrollCard grey lighten-5" max-width="100%" v-if="reservedAppointment.length > 0">
                            <v-card-text class="py-0">
                                <v-timeline align-top dense>
                                    <v-slide-x-reverse-transition group>
                                        <v-timeline-item v-for="(list, index) in reservedAppointment" :key="index" color="blue darken-4" small>
                                            <v-layout row wrap> 
                                                <v-flex lg6 xs12>
                                                    <v-card-title class="subheading font-weight-black pb-0">
                                                        Control Number: {{list.transactionId}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black pt-0 pb-0">
                                                        {{list.branch}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.formatedDate }}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.appointmentTime }}
                                                    </v-card-title>
                                                </v-flex>
                                                    
                                                <v-flex lg6 xs12> 
                                                    <v-btn dark outline color="warning" @click="requestForChange(list),rescheduleDialog=true,fetchEstimatedTime(list) ,calendarValidation(list.branch)">Reschedule Appointment</v-btn>

                                                    <v-btn dark color="red accent-4" @click="requestForCancellation(list),cancelDialog=true">Cancel Appointment</v-btn>

                                                    <v-card-title class="subheading font-weight-black pb-0">Work Requested : 
                                                        <v-flex xs12 v-for="(service,index) in list.initialService" :key="index">
                                                            <li class="subheading font-weight-bold left">{{service.displayName}}</li> 
                                                        </v-flex> 
                                                    </v-card-title> 

                                                    <v-card-title class="subheading font-weight-black pt-0" v-if="list.otherService.length > 0">Others : 
                                                        <v-flex xs12 v-for="(service,index) in list.otherService" :key="index">
                                                            <li class="left subheading font-weight-regular">{{service.service}}</li> 
                                                        </v-flex> 
                                                    </v-card-title>
                                                </v-flex> 
                                            </v-layout>
                                        </v-timeline-item>
                                    </v-slide-x-reverse-transition>
                                </v-timeline>
                            </v-card-text>
                        </v-card>
     
                        <v-layout v-else-if="reservedAppointment.length === 0" row wrap class="mx-auto scrollCard grey lighten-5">
                            <v-flex xs12 sm12 md12 lg12>
                                <div class="text-xs-center">
                                    <br><br>
                                    <v-icon size="80">event_busy</v-icon>
                                    <v-card-title class="headline font-weight-regular justify-center">NO PENDING TRANSACTIONS
                                    </v-card-title>
                                    <br><br>
                                </div>
                            </v-flex>
                        </v-layout> 
                    </v-expansion-panel-content>
                    
                    <v-expansion-panel-content class= "blue-grey darken-3">
                        <template v-slot:actions>
                        <v-icon color="green lighten-1">$vuetify.icons.expand</v-icon>
                        </template>
                        <template v-slot:header>
                            <div>
                                <v-card-title class="title font-weight-medium white--text">MY COMPLETED APPOINTMENTS</v-card-title>
                            </div>
                        </template>

                        <v-card v-if="completedAppointments.length > 0" class="mx-auto scrollCard grey lighten-5" max-width="100%">
                            <v-card-text class="py-0">
                                <v-timeline align-top dense>
                                    <v-slide-x-reverse-transition group>
                                        <v-timeline-item  v-for="(list, index) in completedAppointments" :key="index" color="green darken-4" small>
                                            <v-layout row wrap> 
                                                <v-flex lg6 xs12>
                                                    <v-card-title class="subheading font-weight-black pb-0">
                                                       Control Number: {{list.transactionId}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black pt-0 pb-0">
                                                        {{list.branch}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.formatedDate }}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.appointmentTime }}
                                                    </v-card-title>
                                                </v-flex>
                                                    
                                                <v-flex lg6 xs12> 
                                                    <v-card-title class="subheading font-weight-black pb-0">Work Requested : 
                                                        <v-flex xs12 v-for="(service,index) in list.initialService" :key="index">
                                                            <li class="subheading font-weight-bold left">{{service.displayName}}</li> 
                                                        </v-flex> 
                                                    </v-card-title> 

                                                    <v-card-title class="subheading font-weight-black pt-0" v-if="list.otherService.length > 0">Others : 
                                                        <v-flex xs12 v-for="(service,index) in list.otherService" :key="index">
                                                            <li class="left subheading font-weight-regular">{{service.service}}</li> 
                                                        </v-flex> 
                                                    </v-card-title>
                                                </v-flex> 
                                            </v-layout>
                                        </v-timeline-item>
                                    </v-slide-x-reverse-transition>
                                </v-timeline>
                            </v-card-text>
                        </v-card>

                        <v-layout v-else-if="completedAppointments.length === 0" row wrap class="mx-auto scrollCard grey lighten-5">
                        <v-flex xs12 sm12 md12 lg12>
                            <div class="text-xs-center">
                                <br><br>
                                <v-icon size="80">event_busy</v-icon>
                                <v-card-title class="headline font-weight-regular justify-center">NO PAST TRANSACTIONS
                                </v-card-title>
                                <br><br>
                            </div>
                        </v-flex>
                        </v-layout> 
                    </v-expansion-panel-content>

                    <v-expansion-panel-content class= "blue-grey darken-3">
                        <template v-slot:actions>
                        <v-icon color="green lighten-1">$vuetify.icons.expand</v-icon>
                        </template>
                        <template v-slot:header>
                            <div>
                                <v-card-title class="title font-weight-medium white--text">MY CANCELLED APPOINTMENTS</v-card-title>
                            </div>
                        </template>

                        <v-card v-if="cancelledAppointments.length > 0" class="mx-auto scrollCard grey lighten-5" max-width="100%">
                            <v-card-text class="py-0">
                                <v-timeline align-top dense>
                                    <v-slide-x-reverse-transition group>
                                        <v-timeline-item v-for="(list, index) in cancelledAppointments" :key="index"  color="red darken-4" small>
                                            <v-layout row wrap> 
                                                <v-flex lg6 xs12>
                                                    <v-card-title class="subheading font-weight-black pb-0">
                                                       Control Number: {{list.transactionId}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black pt-0 pb-0">
                                                        {{list.branch}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.formatedDate }}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.appointmentTime }}
                                                    </v-card-title>
                                                </v-flex>
                                                    
                                                <v-flex lg6 xs12> 
                                                    <v-card-title class="subheading font-weight-black pb-0">Work Requested : 
                                                        <v-flex xs12 v-for="(service,index) in list.initialService" :key="index">
                                                            <li class="subheading font-weight-bold left">{{service.displayName}}</li> 
                                                        </v-flex> 
                                                    </v-card-title> 

                                                    <v-card-title class="subheading font-weight-black pt-0" v-if="list.otherService.length > 0">Others : 
                                                        <v-flex xs12 v-for="(service,index) in list.otherService" :key="index">
                                                            <li class="left subheading font-weight-regular">{{service.service}}</li> 
                                                        </v-flex> 
                                                    </v-card-title>
                                                </v-flex> 
                                            </v-layout>
                                        </v-timeline-item>
                                    </v-slide-x-reverse-transition>
                                </v-timeline>
                            </v-card-text>
                        </v-card>

                        <v-layout v-else-if="cancelledAppointments.length === 0" row wrap  class="mx-auto scrollCard grey lighten-5">
                            <v-flex xs12 sm12 md12 lg12>
                                <div class="text-xs-center">
                                    <br><br>
                                    <v-icon size="80">event_busy</v-icon>
                                    <v-card-title class="headline font-weight-regular justify-center">NO CANCELLED TRANSACTIONS
                                    </v-card-title>
                                    <br><br>
                                </div>
                            </v-flex>
                        </v-layout> 
                    </v-expansion-panel-content>

                    <v-expansion-panel-content class= "blue-grey darken-3">
                        <template v-slot:actions>
                            <v-icon color="green lighten-1">$vuetify.icons.expand</v-icon>
                        </template>
                        <template v-slot:header>
                            <div>
                                <v-card-title class="title font-weight-medium white--text">MY APPOINTMENTS WITH UNAVAILABLE SLOT</v-card-title>
                            </div>
                        </template>

                        <v-card class="mx-auto scrollCard grey lighten-5" max-width="100%" v-if="rejectedAppointments.length > 0">
                            <v-card-text class="py-0">
                                <v-timeline align-top dense>
                                    <v-slide-x-reverse-transition group>
                                        <v-timeline-item v-for="(list, index) in rejectedAppointments" :key="index" color="blue-grey darken-4" small>
                                            <v-layout row wrap> 
                                                <v-flex lg6 xs12>
                                                    <v-card-title class="subheading font-weight-black pb-0">
                                                       Control Number: {{list.transactionId}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black pt-0 pb-0">
                                                        {{list.branch}}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.formatedDate }}
                                                    </v-card-title>

                                                    <v-card-title class="headline font-weight-black text-md-center pt-0 pb-0">
                                                        {{ list.appointmentTime }}
                                                    </v-card-title>
                                                </v-flex>
                                                    
                                                <v-flex lg6 xs12> 
                                                    <v-card-title class="subheading font-weight-black pb-0">Work Requested : 
                                                        <v-flex xs12 v-for="(service,index) in list.initialService" :key="index">
                                                            <li class="subheading font-weight-bold left">{{service.displayName}}</li> 
                                                        </v-flex> 
                                                    </v-card-title> 

                                                    <v-card-title class="subheading font-weight-black pt-0" v-if="list.otherService.length > 0">Others : 
                                                        <v-flex xs12 v-for="(service,index) in list.otherService" :key="index">
                                                            <li class="left subheading font-weight-regular">{{service.service}}</li> 
                                                        </v-flex> 
                                                    </v-card-title>
                                                </v-flex> 
                                            </v-layout>
                                        </v-timeline-item>
                                    </v-slide-x-reverse-transition>
                                </v-timeline>
                            </v-card-text>
                        </v-card>

                        <v-layout v-else-if="rejectedAppointments.length === 0" row wrap  class="mx-auto scrollCard grey lighten-5">
                            <v-flex xs12 sm12 md12 lg12>
                                <div class="text-xs-center">
                                    <br><br>
                                    <v-icon size="80">event_busy</v-icon>
                                    <v-card-title class="headline font-weight-regular justify-center">NO REJECTED TRANSACTIONS
                                    </v-card-title>
                                    <br><br>
                                </div>
                            </v-flex>
                        </v-layout> 
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-container>

            <v-layout row wrap>
    
            <v-dialog v-model="rescheduleDialog" persistent max-width="70%">
                <!-- LARGE DEVICE -->
                <v-card class="pa-0 hidden-sm-and-down">
                    <v-card-title class="title font-weight-black pb-0">
                    Reschedule Appointment
                    </v-card-title>
                    <v-card-title class="subheading font-weight-regular pt-0 pb-0">
                    Select the time that best fits your schedule
                    </v-card-title> 

                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs7>
                                <v-card-title v-model="branchname" ref="branchname" class="subheading font-weight-bold pt-0 pb-0 pl-0" >
                                    Branch : {{forChange.branch}}
                                </v-card-title>
                                
                                <v-card-title v-model="branchId" ref="branchId" class=" caption font-weight-regular pl-0 pt-0 pb-0" v-if="showID">
                                Control Number : {{forChange.transactionId}}
                                </v-card-title>

                                <v-date-picker v-model="mainCalendar" header-color="red" full-width class="mt-3" :min="date" :max="maximumDate" :allowed-dates="allowedDates" :events="arrayEvents" :value="computedDateFormattedMomentjs">
                                </v-date-picker>

                                <v-layout justify-center>
                                    <v-card-actions class="pt-4">
                                        <v-btn color="red accent-4" dark  @click="reload()">Cancel</v-btn>
                                        <v-btn color="blue darken-4" dark @click="confirmDialog=true">Save</v-btn>
                                    </v-card-actions>
                                </v-layout>
                            </v-flex>

                            <v-flex xs5>
                                <v-container grid-list-md text-xs-center>
                                    <v-layout row wrap>
                                        <v-flex xs12 v-if="!arrayEvents.includes(mainCalendar)">
                                            <v-combobox v-model="mechanic" :items="mechanics" label="Select Mechanic*" hide-details></v-combobox>
                                        </v-flex>

                                        <v-flex xs6>
                                            <v-card-title height=10 class="headline font-weight-medium pb-0">AM
                                            </v-card-title>

                                            <v-radio-group v-model="schedtime" row v-if="mainCalendar==timepast.split(', ')[0].trim()">
                                                <v-radio v-for="list in times" :key="list" v-if="list.includes('am') && new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                            </v-radio-group>

                                             <v-radio-group v-else v-model="schedtime" row>
                                                <v-radio v-for="list in times" :key="list" v-if="list.includes('am')" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                            </v-radio-group>
                                        </v-flex>

                                        <v-flex xs6>
                                            <v-card-title height=10 class="headline font-weight-medium pb-2">PM
                                            </v-card-title>
                                            
                                            <v-radio-group v-if="mainCalendar==timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                <v-radio v-for="list in times" :key="list" v-if="list.includes('pm') &&  new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                            </v-radio-group>

                                            <v-radio-group v-else v-model="schedtime" row>
                                                <v-radio v-for="list in times" :key="list" v-if="list.includes('pm')" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>

                <!-- SMALL DEVICE -->
                <v-card class="pa-0 hidden-md-and-up">
                    <v-card-title class="title font-weight-black pb-0">
                    Reschedule Appointment
                    </v-card-title>
                    <v-card-title class="caption font-weight-regular pt-0 pb-0">
                    Select the time that best fits your schedule
                    </v-card-title> 

                    <v-container grid-list-md>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card-title v-model="branchname" ref="branchname" class="subheading font-weight-bold pt-0 pb-0 pl-0" >
                                    Branch : {{forChange.branch}}
                                </v-card-title>
                                
                                <v-card-title v-model="branchId" ref="branchId" class="caption font-weight-regular pl-0 pt-0 pb-0" v-if="showID">
                                Control Number : {{forChange.transactionId}}
                                </v-card-title>

                                <v-date-picker v-model="mainCalendar" header-color="red" full-width class="mt-3" :min="date" :max="maximumDate" :allowed-dates="allowedDates" :events="arrayEvents" :value="computedDateFormattedMomentjs">
                                </v-date-picker>
                            </v-flex>

                            <v-flex xs12>
                                <v-container grid-list-md text-xs-center>
                                    <v-layout row wrap>
                                        <v-flex xs12 v-if="!arrayEvents.includes(mainCalendar)">
                                            <v-combobox v-model="mechanic" :items="mechanics" label="Select Mechanic" hide-details></v-combobox>
                                        </v-flex>

                                        <v-flex xs6>
                                            <v-card-title height=10 class="headline font-weight-medium pb-0">AM
                                            </v-card-title>

                                            <v-radio-group v-if="mainCalendar==timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                <v-radio v-for="list in times" :key="list" v-if="list.includes('am') && new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                            </v-radio-group>

                                            <v-radio-group v-else v-model="schedtime" row>
                                                <v-radio v-for="list in times" :key="list" v-if="list.includes('am')" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                            </v-radio-group>
                                        </v-flex>

                                        <v-flex xs6>
                                            <v-card-title height=10 class="headline font-weight-medium pb-2">PM
                                            </v-card-title>
                                            
                                            <v-radio-group v-if="mainCalendar==timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                <v-radio v-for="list in times" :key="list" v-if="list.includes('pm') &&  new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                            </v-radio-group>

                                            <v-radio-group v-else v-model="schedtime" row>
                                                <v-radio v-for="list in times" :key="list" v-if="list.includes('pm')" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>

                            <v-layout justify-center>
                                <v-card-actions class="pt-4">
                                    <v-btn color="red accent-4" dark  @click="reload()">Cancel</v-btn>
                                    <v-btn color="blue darken-4" dark @click="confirmDialog=true">Save</v-btn>
                                </v-card-actions>
                            </v-layout>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="confirmDialog" max-width="500px" persistent>
                <v-card>
                    <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="80">
                        <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Are you sure you want to re-schedule this appointment? </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to change the schedule of your request appointment. This will be confirm once approve by the branch.
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="confirmDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="changeSchedule(forChange)">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="cancelDialog" persistent max-width="500px">
                <v-card>
                    <v-parallax dark class="blue-grey darken-3" height="70">
                        <v-layout>
                            <h4 class="title font-weight-medium pt-3">Are you sure you want to cancel your appointment? </h4>
                        </v-layout>
                    </v-parallax> 

                    <v-card-text class="subheading font-weight-regular">
                       You are about to cancel the selected appointment. This will remove you from the list of self-service appointments in branch and considered as walk-in upon arrival. 
                    </v-card-text>
                    <v-card-text class="subheading font-weight-regular">
                      Are you sure you want to proceed?
                    </v-card-text>
                    <div class="pl-3 pr-3 pb-3 pt-0">
                        <v-select v-model="reason" outline label="Reason" required :items="reasons" hide-details
                        ></v-select>
                    </div>
                    <v-card-actions class="justify-center">
                        <v-btn dark color="red accent-4" @click="cancelDialog=false">NO</v-btn>
                        <v-btn dark color="blue darken-4" @click="(cancelSchedule(forCancellation))">YES</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-flex xs6></v-flex>

            </v-layout>

            <Progress v-model="progress.show" :message="progress.message" />
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
        </v-app>
    </div>
</template>

<script>
import {db} from '../main'
import { mapGetters, mapState } from "vuex"
import { setTimeout } from 'timers'
import _ from 'lodash'
import moment from 'moment'
import { stage } from '../../appConfig'
import Progress from './Progress.vue'
import Snackbar from './Snackbar.vue'

export default {
    components: {
        Progress,
        Snackbar
    },
    data() {
        return {
            interval: null,
            nonce: 2,
            forChange: [],
            forCancellation: [],
            forApproval: [],
            reservedAppointment: [],
            cancelledAppointments: [],
            completedAppointments: [],
            rejectedAppointments: [],
            color: [],
            rescheduleDialog: false,
            date: moment().utcOffset('+0800').toISOString().substr(0, 10),
            schedtime: "",
            times: [],
            mainCalendar: moment().utcOffset('+0800').toISOString().substr(0, 10),
            allowedDates: null,
            cancelDialog: false,
            removed: [],
            branchname: "",
            branchCode: "",
            branchId: "",
            estimateTime: 0,
            showID: true,
            timeout: 2000,
            lists: [],
            panel: [true, false, false],
            btnSet: true,
            laps: [],
            timeValidation: [],
            timeValidation2: [],
            timeRemoveHolder: [],
            timesChecker: [],
            maximumDate: moment().add(3, 'months').toISOString().substr(0, 10),
            branchMechanics: [],
            mechanics: [],
            mechanic: "", 
            arrayEvents: [],
            reason: "",
            reasons: [],
            bufferTime: 0,
            confirmDialog: false,
            timepast: moment().format('YYYY-MM-DD, hh:mm a'),
            selectedBranchId: "",
            snackbar: {
                responseMessage: "",
                show: false,
                type: "success"
            },
            progress: {
                message: "",
                show: false,
            },
        }
    },

    methods : {
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },

        async fetchBufferTime() {
            let self = this
            await db.collection("Settings"+self.$stage).doc("BufferTime")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.bufferTime = 0
                        self.showSnackbarMessage("Buffer time should be set", false)  
                    } else {
                        self.bufferTime = doc.data().time
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Buffer time should be set", false)
            })
        },

        async fetchReasons() {
            let self = this
            self.reasons = []

            db.collection("Settings"+self.$stage).doc("Cancellation")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    self.reasons.push(doc.data().reason)
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Please set-up reason for cancellation", false)
            })
        },

        fetchMechanics() {
            let self = this
            let mechanics = []
            let scheduleMechanics = []
            if (self.forChange) {
                db.collection("Mechanics"+self.$stage).get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc){
                        if(doc.data().status === "Active") {
                            mechanics.push(doc.data())
                        }
                    })
                }).then(function(){
                    if (mechanics) {
                        mechanics.forEach(function(res) {
                            if(res.branch === self.$refs.branchname.textContent.split(' : ')[1].trim()) {
                                self.branchMechanics.push(res)
                            }
                        })
                    }
                }).then(function() {
                    if (self.branchMechanics) {
                        self.branchMechanics.forEach(function(res) {
                            if (res.tag === true) {
                                scheduleMechanics.push(res)
                            }
                        })
                    }
                }).then(function() {
                    if (scheduleMechanics) {
                        scheduleMechanics.forEach(function(res) {
                            self.mechanics.push(res.name)
                        })
                    }
                }).then(function(){
                    if (self.mechanics.length === 1) {
                        self.mechanic = self.mechanics[0]
                    }
                })
            }
        },
        
        timeUpdate() {
            let self = this
            let index = []
            let index2 = []
            
            if (self.timeValidation.appointmentTime != "" && self.timeValidation.appointmentTime != null) { 
                index = self.times.indexOf(self.timeValidation.appointmentTime)
                self.removed = self.times.splice(index, self.timeValidation.blockTime)
            }

            if (self.timeValidation2.appointmentTime != "" && self.timeValidation2.appointmentTime != null) { 
                index2 = self.times.indexOf(self.timeValidation2.appointmentTime)
                self.removed = self.times.splice(index2, self.timeValidation2.blockTime)
            }
        },

        requestForChange(reservedAppointment) {
            let self = this
            self.times = []

            db.collection("ServiceBooking"+self.$stage).doc(reservedAppointment.transactionId)
            .get().then(function(doc) {
                self.forChange = doc.data()
                self.branchCode = doc.data().branchCode
                self.selectedBranchId = doc.data().branchId
                self.branchname = doc.data().branch
            }).catch(function(error){
                console.log(error)
            })
        },

        changeSchedule(forChange) {
            let self = this
            self.rescheduleDialog = false
            self.confirmDialog = false
            if (self.schedtime != "" && self.removed !=[] && self.schedtime != null) {
                self.timeUpdate()
                self.showProgress("Updating...") 
                db.collection("ServiceBooking"+self.$stage).doc(forChange.transactionId)
                .update({
                    appointmentDate: self.mainCalendar,
                    appointmentTime: self.schedtime,
                    status: "ForApproval",
                    formatedDate: self.computedDateFormattedMomentjs,
                    timeHold: self.removed,
                    dateModified: moment().format('MMMM Do YYYY, h:mm:ss a')
                })
                .then(function() {
                    self.notifications(self.forChange.branch, self.forChange.transactionId)
                    setTimeout(() => {
                        self.stopProgress()
                        self.showSnackbarMessage("Successfully updated", true)
                        self.schedtime = ""
                    }, 1000)
                })
            } else {
                self.showSnackbarMessage("Please pick date & time", false)
                self.rescheduleDialog = true
            }
        },

        requestForCancellation (cancelledAppointments) {
            let self = this
            self.forCancellation=[]
            db.collection("ServiceBooking"+self.$stage).doc(cancelledAppointments.transactionId)
            .get().then(function(doc) {
                self.forCancellation = doc.data()
            }).catch(function(error){
                console.log(error)
            })
        },

        async cancelSchedule(forCancellation) {
            let self = this
            
            if (self.reason !== "" && self.reason !== null) {
                self.cancelDialog = false
                self.showProgress("Cancelling...")

                await db.collection("ServiceBooking"+self.$stage).doc(forCancellation.transactionId)
                .update({
                    status: "Cancelled",
                    timeHold: [],
                    remarks: self.reason,
                    dateModified: moment().format('MMMM Do YYYY, h:mm:ss a')
                }).then(async function() {
                    await fethchTransactions()
                    self.stopProgress()
                }).catch(function(error){
                    console.log(error)
                })
            } else {
                self.showSnackbarMessage("Please select reason for cancellation",false)
            }
        },

        async fethchTransactions() { 
            let self = this
            await db.collection("ServiceBooking"+self.$stage)
            .where("userDetails.email","==",self.user.email)
            .onSnapshot(function(querySnapshot) {
                self.forApproval = []
                self.reservedAppointment = []
                self.completedAppointments = []
                self.cancelledAppointments = []
                self.rejectedAppointments = []
                querySnapshot.forEach(function(doc) {
                    if (doc.data().status === "ForApproval" && doc.data().userDetails.email === self.user.email) {
                        self.forApproval.push(doc.data())
                    } else if (doc.data().status === "Waiting" && doc.data().userDetails.email === self.user.email) {
                        self.reservedAppointment.push(doc.data())
                    } else if (doc.data().status === "Completed" && doc.data().userDetails.email === self.user.email) {
                        self.completedAppointments.push(doc.data())
                    } else if (doc.data().status === "Cancelled" && doc.data().userDetails.email === self.user.email) {
                        self.cancelledAppointments.push(doc.data())
                    } else if (doc.data().status === "Rejected" && doc.data().userDetails.email === self.user.email) {
                        self.rejectedAppointments.push(doc.data())
                    }
                })

                self.forApproval = (_.sortBy(self.forApproval, 'appointmentDate')).reverse()
                self.reservedAppointment = (_.sortBy(self.reservedAppointment, 'appointmentDate')).reverse()
                self.completedAppointments = (_.sortBy(self.completedAppointments, 'appointmentDate')).reverse()
                self.cancelledAppointments = (_.sortBy(self.cancelledAppointments, 'appointmentDate')).reverse()
                self.rejectedAppointments = (_.sortBy(self.rejectedAppointments, 'appointmentDate')).reverse()
                self.stopProgress()
            })

            // self.forApproval = []
            // self.reservedAppointment = []
            // self.completedAppointments = []
            // self.cancelledAppointments = []
            // self.rejectedAppointments = []
            // await db.collection("ServiceBooking"+self.$stage)
            // .where("userDetails.email","==",self.user.email)
            // .get().then(function(querySnapshot) {
            //     querySnapshot.forEach(function(doc) {
            //         if (doc.data().status === "ForApproval" && doc.data().userDetails.email === self.user.email) {
            //             self.forApproval.push(doc.data())
            //         } else if (doc.data().status === "Waiting" && doc.data().userDetails.email === self.user.email) {
            //             self.reservedAppointment.push(doc.data())
            //         } else if (doc.data().status === "Completed" && doc.data().userDetails.email === self.user.email) {
            //             self.completedAppointments.push(doc.data())
            //         } else if (doc.data().status === "Cancelled" && doc.data().userDetails.email === self.user.email) {
            //             self.cancelledAppointments.push(doc.data())
            //         } else if (doc.data().status === "Rejected" && doc.data().userDetails.email === self.user.email) {
            //             self.rejectedAppointments.push(doc.data())
            //         }
            //     })
            // }).then(function() {
            //     console.log("done")
            //     self.forApproval = (_.sortBy(self.forApproval, 'appointmentDate')).reverse()
            //     self.reservedAppointment = (_.sortBy(self.reservedAppointment, 'appointmentDate')).reverse()
            //     self.completedAppointments = (_.sortBy(self.completedAppointments, 'appointmentDate')).reverse()
            //     self.cancelledAppointments = (_.sortBy(self.cancelledAppointments, 'appointmentDate')).reverse()
            //     self.rejectedAppointments = (_.sortBy(self.rejectedAppointments, 'appointmentDate')).reverse()
            // })
        },

        notifications(branch,transactionId) {
            let self = this
            let count = 0
            let source = ""
            let branchUsers = []

            self.$axios.defaults.headers.common['Authorization'] = self.$smsAuthorization
            self.$axios.defaults.headers.common['Content-Type'] = self.$contentType

            if (branch.includes("Transcycle")) {
                source = "Transcycle"
            } else if (branch.includes("Powercycle")) {
                source = "Powercycle" 
            }

            let branchMessage = "Dear " + branch + ",\n\n"+ self.user.fullName + " has requested an rescheduled appointment on " + self.computedDateFormattedMomentjs + " at " + self.schedtime+ " with control number "+ transactionId +". \n\n"+ "Click here to see full details of appointment".link(self.$branchUrl +'/service-approval') +"\n\n"+"Your approval is required."+ "\n\n" + "Thank you."

            let branchsmsmessage = "Dear " + branch + ",\n\n"+ self.user.fullName + " has requested an rescheduled appointment on " + self.computedDateFormattedMomentjs +" at "+ self.schedtime +" with control number " + transactionId +". \n\n" + "Click here to see full details of the appointment: " + self.$branchUrl +'/service-approval' +"\n\n"+"Your approval is required."+ "\n\n" + "Thank you."
            
            let branchEmailMessage = branchMessage.replace(/(\r\n|\n|\r)/gm, "<br>")

            db.collection("branchUsers"+self.$stage).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    branchUsers.push(doc.data())
                })
            }).then(function() {
                branchUsers.forEach(function(data) {
                    count ++
                    if(data.branch == branch) {
                        let mailerBody = {
                            "receiver" : data.email,
                            "subject" : "Customer rescheduled service appointment",
                            "html" : branchEmailMessage
                        }
                        let smsBody = {
                            "source": source,
                            "destination": "63" + data.mobileNumber,
                            "text": branchsmsmessage,
                        }
                        self.$axios.post(self.$smsUrl, smsBody).then(function(){
                            self.$axios.post(self.$mailerUrl, mailerBody).then(function() {
                                if(count === branchUsers.length) {
                                    setTimeout(() => {
                                       self.reload() 
                                    }, 2000)
                                }
                            })
                        })
                    }
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        calendarValidation(branch) {
            let self = this
            let getEvents = []
            let getLoad = []
            let totalTimeHold = []
            let pivot = null

            db.collection("Events"+self.$stage)
            // .where("branch","==",`${self.branchCode}_${self.branch}`)
            .where("branchId","==", self.selectedBranchId)
            .where("status","==","approved")
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.lists.push(doc.data())
                })

                self.lists.forEach(function(res) {
                    if (res.timeHold.length > 24) {
                        getEvents.push(res.date)
                        self.arrayEvents.push(res.date)
                    }
                })
            }).then(function(){
                db.collection("ServiceBooking"+self.$stage).get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        if (doc.data().branch == self.branch && doc.data().status == "Waiting") {
                            getLoad.push(doc.data())
                        }
                    })

                    if (getLoad) {
                        pivot = _(getLoad).groupBy('appointmentDate')
                        .map((item, key) => ({
                            appointmentDate: key,
                            timeHold: _.map(item, 'timeHold'),
                            totalTimeHold: _.sumBy(_.map(item, 'timeHold.length'))
                        })).value()

                        pivot.forEach(function(data) {
                            if(data.totalTimeHold > 24) {
                                getEvents.push(data.appointmentDate)
                                self.arrayEvents.push(data.appointmentDate)
                            }
                        })
                    }

                }).then(function(){
                    self.allowedDates = val =>
                    ![0].includes(new Date(val).getDay())&&!getEvents.includes(moment(val).utcOffset('+0800').toISOString().substr(0, 10),)
                })
            })
        },

        fetchEstimatedTime(list) {
            let self = this
            self.estimateTime = list.estimateTime
        },

        reload() {
            window.location.reload()
        },

        checkMechanics(val) {
            let self = this
            let availableTime = []
            let removedFromDb = []
            let blockTime = 0
            let appointmentTime = ""
            let index = []
            self.removed = []
            self.timeValidation = []
            self.timeValidation2 = []
            self.laps = []
            self.dialog=true
            self.showProgress("Loading...")

            if(val) {
                self.schedtime = null
                db.collection("Mechanics"+self.$stage)
                .where("name","==",val)
                // .where("branchCode","==",self.branchCode)
                .where("branchId","==", self.selectedBranchId)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        self.times = doc.data().time
                    })
                }).then(function() {
                    db.collection("ServiceBooking"+self.$stage)
                    //.where("branch","==",self.$refs.branchname.textContent.split(' : ')[1].trim())
                    .where("branchId","==", self.selectedBranchId)
                    .where("appointmentDate","==",self.mainCalendar)
                    .where("status","==","Waiting")
                    .where("mechanic","==",val)
                    .get().then(function(querySnapshot) {
                        if (querySnapshot.docs.length > 0) {
                            querySnapshot.forEach(function(doc) {  
                                self.timeValidation.push({
                                    appointmentTime: doc.data().appointmentTime,
                                    blockTime: doc.data().estimateTime / self.bufferTime
                                })
                            })

                            self.timeValidation.forEach(function(val) {
                                index = self.times.indexOf(val.appointmentTime)
                                removedFromDb = self.times.splice(index, val.blockTime)
                                self.laps.push(removedFromDb)
                            })
                            self.stopProgress()
                        } else {
                            self.timeValidation = {
                                appointmentTime: self.schedtime,
                                blockTime: self.estimateTime / self.bufferTime
                            }
                            self.stopProgress()
                        }
                    })
                })
            }  else {
                self.stopProgress()
            }
        },

    },

    async mounted() {
        await this.fethchTransactions()
        await this.fetchReasons()
        await this.fetchBufferTime()
    },

    computed: {
         computedDateFormattedMomentjs () {
                return this.mainCalendar ? moment(this.mainCalendar).format('dddd, MMMM Do YYYY') : ''
            },
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {
        rescheduleDialog: function(val) {
            this.fetchMechanics()
        },

        mainCalendar: function(val) {
            let self = this
            let adminTime = []
            let adminTimeProcess = 0
            let availableTime = []
            self.mechanic = ""
            self.times = []

            if (self.mechanics.length === 1) {
                self.mechanic = self.mechanics[0]
            } else {
                self.mechanic = ""
            }

            if(self.forChange) {
                db.collection("Events"+self.$stage)
                .where("branchId","==",self.selectedBranchId)
                .where("status","==","approved")
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        adminTime.push(doc.data())
                        adminTimeProcess ++
                    })
                }).then(function() {
                    if(adminTimeProcess === adminTime.length) {
                        adminTime.forEach(function(res) {
                            if(res.date == self.mainCalendar) {
                                availableTime=res
                            }
                        })
                        try {
                            if( self.mainCalendar != ""){
                                self.times = self.times.filter(value => !availableTime.timeHold.includes(value))
                            }
                        } catch(err) {}
                    }
                }).then(function(){
                    self.calendarValidation(self.$refs.branchname.textContent.split(' : ')[1].trim())
                    self.checkMechanics(self.mechanic)
                })
            }
            // let self = this
            // let adminTime = []
            // let adminTimeProcess = 0
            // self.mechanic = ""
            // self.times = []

            // if (self.mechanics.length === 1) {
            //     self.mechanic = self.mechanics[0]
            // } else {
            //     self.mechanic = ""
            // }

            

            // if(self.forChange) {
            //     db.collection("Admin"+self.$stage).doc(self.$refs.branchname.textContent.split(' : ')[1].trim())
            //         .collection("Events").get().then(function(querySnapshot) {
            //             querySnapshot.forEach(function(doc) {
            //                 adminTime.push(doc.data())
            //                 adminTimeProcess ++
            //             })
            //         }).then(function() {
            //             if(adminTimeProcess === adminTime.length) {
            //                 adminTime.forEach(function(res) {
            //                     if(res.date == self.mainCalendar) {
            //                         availableTime=res
            //                     }
            //                 })
            //                 try {
            //                     if( self.mainCalendar != ""){
            //                         self.times = self.times.filter(value => !availableTime.timeHold.includes(value))
            //                     }
            //                 } catch(err) {}
            //             }
            //         }).then(function(){
            //             self.calendarValidation(self.$refs.branchname.textContent.split(' : ')[1].trim())
            //             self.checkMechanics(self.mechanic)
            //         })
            // }
        },

        schedtime: function(val) {
            let self = this
            let index2 = []
            let lapsChecker = []
            self.timeRemoveHolder = []
            self.timesChecker = ["09:00AM","09:30AM","10:00AM", "10:30AM","11:00AM","11:30AM","01:00PM","01:30PM","02:00PM","02:30PM", "03:00PM","03:30PM","04:00PM"]

            self.timeValidation2 = {
                appointmentTime: self.schedtime,
                blockTime: self.estimateTime / self.bufferTime
            }

            if (self.timeValidation2.appointmentTime != "" && self.timeValidation2.appointmentTime != null) {      index2 = self.timesChecker.indexOf(self.timeValidation2.appointmentTime)
                self.timeRemoveHolder = self.timesChecker.splice(index2, self.timeValidation2.blockTime)
                self.laps = [].concat.apply([], self.laps)

                self.timeRemoveHolder.forEach(function(doc) {
                    if(self.laps.includes(doc)) {
                        lapsChecker.push(doc)
                    }
                })
                
                if(lapsChecker.length > 0) {
                    self.showSnackbarMessage("Cannot accomodate service in your selected hours. Please select another time",false)
                    setTimeout(() => {
                        self.schedtime = null
                    }, 500)
                }
            }
        },
        
        mechanic: function(val) {
            this.checkMechanics(val)
        },
    }
}

</script>

<style scoped>
    .scrollCard {
        overflow-y: auto;
    }
</style>


</style>
